import { render, staticRenderFns } from "./FolderPicker.vue?vue&type=template&id=4d2530f1&scoped=true&"
import script from "./FolderPicker.vue?vue&type=script&lang=js&"
export * from "./FolderPicker.vue?vue&type=script&lang=js&"
import style0 from "./FolderPicker.vue?vue&type=style&index=0&id=4d2530f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2530f1",
  null
  
)

export default component.exports